import { CURRENT_LANGUAGE_LOCAL_STORAGE_KEY } from '@shared/translate/constants';
import { Language } from '@shared/translate/enums';
import { LanguageData } from '@shared/translate/interfaces';
import { getRawTranslation } from '@shared/translate/utils/get-raw-translation';
import { getLanguageData } from '@shared/translate/utils/language.utils';
import { formatMoneyString } from '@shared/utils';
import { getLocalStorage } from './local-storage';
import { showNotification } from './show-notification';

export async function processReward(amount: number): Promise<void> {
  try {
    const moneyReward: string = formatMoneyString(amount);
    const language: Language = (await getLocalStorage(CURRENT_LANGUAGE_LOCAL_STORAGE_KEY)) || Language.English;
    const languageData: LanguageData = getLanguageData(language)!;
    
    const title: string = await getRawTranslation('student.reward.title', language);
    const message: string = await getRawTranslation('student.reward.added_to_balance', language);

    showNotification(title, `${languageData.currencySign}${moneyReward} ${message}`);
  } catch (error) {
    console.error('Error processing reward', error);
  }
}
